import { useState, useCallback } from 'react'
import { checkUnfinishedEnrollment } from '../libs/CloudFunctionsApiHandler'
import { Enrollment } from '../../../pure-js/types/GrooverTypes'

type CheckUnfinishedEnrollmentArgs = {
  clientId: string
  activityId: string
  phoneNumber: string
  partnerPhoneNumber?: string
}

type UseCheckUnfinishedEnrollmentResult = {
  check: (args: CheckUnfinishedEnrollmentArgs) => Promise<Enrollment | null>
  isLoading: boolean
}

export const useCheckUnfinishedEnrollment = (): UseCheckUnfinishedEnrollmentResult => {
  const [isLoading, setIsLoading] = useState(false)

  const check = useCallback(async (args: CheckUnfinishedEnrollmentArgs): Promise<Enrollment | null> => {
    setIsLoading(true)
    try {
      const result = await checkUnfinishedEnrollment(args)
      return result
    } catch (error) {
      console.error('[useCheckUnfinishedEnrollment] error', error)
      return null
    } finally {
      setIsLoading(false)
    }
  }, [])

  return { check, isLoading }
}
